import HotelRatingSquare from './HotelRatingSquare';

export default HotelRatingSquare;
